export default __webpack_public_path__ + "static/media/4.7e74020e.jpg";